import { Phone, MapPin, Navigation } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { BUSINESS, MAPS_EMBED_URL, DIRECTIONS_URL } from "../config/business";

export const Contact = () => (
  <section id="contact" className="bg-[#0b0c0e] py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal>
        <SectionHeading kicker="Visit or Call" title="Find Us in Mississauga" />
      </Reveal>

      <Reveal delay={0.1}>
        <div className="image-frame mt-12 overflow-hidden border border-white/10">
          <iframe
            data-testid="contact-map"
            title="Map showing Auto Trust Centre at 5040 Maingate Dr #1, Mississauga, ON"
            src={MAPS_EMBED_URL}
            className="h-[440px] w-full grayscale-[35%] contrast-[1.05]"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-8 flex flex-col justify-between gap-6 border border-white/10 bg-[#17181c] p-7 lg:flex-row lg:items-center">
          <address className="not-italic">
            <p className="font-display text-xl font-bold uppercase text-[#f4f4f2]">
              {BUSINESS.name}
            </p>
            <p className="mt-2 flex items-start gap-2.5 text-[#c9ccd2]">
              <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-[#00AEEF]" />
              <span>
                {BUSINESS.addressLines.map((l) => (
                  <span key={l} className="block">{l}</span>
                ))}
              </span>
            </p>
            <a
              href={BUSINESS.phoneHref}
              className="mt-2 flex items-center gap-2.5 font-semibold text-[#c9ccd2] transition-colors hover:text-white"
            >
              <Phone className="h-5 w-5 shrink-0 text-[#00AEEF]" />
              {BUSINESS.phone}
            </a>
          </address>
          <div className="flex flex-col gap-4 sm:flex-row">
            <a data-testid="contact-call-button" href={BUSINESS.phoneHref} className="btn-ghost">
              <Phone className="h-4 w-4 text-[#00AEEF]" />
              Call the Shop
            </a>
            <a
              data-testid="contact-directions-button"
              href={DIRECTIONS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              <Navigation className="h-4 w-4" />
              Get Directions
            </a>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
